import { pushGTMEvent } from 'containers/Player/utils/analytics';

export const getParameterByName = (name, url) => {
  const newName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);

  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const pushBeginCheckoutEvent = plan => {
  const gtmEventInfo = {
    event: 'begin_checkout',
    item_id: plan.offerid,
    item_name: plan.producttype.toLowerCase(),
    item_category: 'canal tv',
    item_category_2: 'no aplica',
    item_category_3:
      plan.oneoffertype === 'subscrition'
        ? `por suscripcion${
            plan.family === 'clarovideo' ? '' : ` ${plan.family}`
          }`
        : '',
    item_category_4: 'no aplica',
    item_brand: plan.family,
    item_list_name: 'home inicio',
    price: plan.price,
    quantity: '1',
  };
  pushGTMEvent(gtmEventInfo);
};
